<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="card-container">
                    <div class="page-title-wrapper">
                        <div class="header-title-wrapper">
                            <div class="header-title">企业中心</div>
                            <div class="header-title">
                                <img src="@/assets/img/more.png" alt="" class="header-title-img">
                            </div>
                            <div class="header-title title-cursor" @click="handleBack('offline-course')">
                                线下公开课
                            </div>
                            <div class="header-title">
                                <img src="@/assets/img/more.png" alt="" class="header-title-img">
                            </div>
                            <div class="header-title">课程详情</div>
                        </div>
                    </div>
                </div>

                <div class="card-container">
                    <div class="card-wrapper">
                        <div class="card-header">
                            前端工程师零基础转行就业入门班
                            <div class="card-header-line"></div>
                        </div>
                        <div class="card-content-wrapper">
                            <div class="card-info">
                                <img src="@/assets/img/clock3.png" alt="" class="clock-img">
                                时间：2021-11-26  08:50:00
                            </div>
                            <div class="card-info">
                                <i class="el-icon-location card-info-icon"></i>
                                地点：北京 朝阳区东四环中路82号
                            </div>
                            <div class="card-info-btn-wrapper">
                                <div class="card-info-btn">签到</div>
                                <div class="card-info-btn">预约管理</div>
                                <div class="card-info-btn">学习测评</div>
                                <div class="card-info-btn">调查问券</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="course-container">
                    <div class="course-header-wrapper">
                        <div :class="activeTab=='brief'?'course-header-item-active':'course-header-item'" 
                        @click="handleTab('brief')">
                            简介
                        </div>
                        <div :class="activeTab=='detail'?'course-header-item-active':'course-header-item'"
                        @click="handleTab('detail')">
                            课程资料
                        </div>
                        <div :class="activeTab=='rules'?'course-header-item-active':'course-header-item'"
                        @click="handleTab('rules')">
                            相关法规
                        </div>
                    </div>
                    <div v-if="activeTab=='brief'" class="course-content-wrapper">
                        <div class="course-content-header">
                            <div class="circle-img1-wrapper">
                                <img src="@/assets/img/circle1.png" alt="" class="circle-img1">
                            </div>
                            <div class="circle-img2-wrapper">
                                <img src="@/assets/img/circle2.png" alt="" class="circle-img2">
                            </div>
                            <div class="course-content-header-title">课程概述</div>
                        </div>
                        <div class="course-brief-content">
                            扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，
                            对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...
                            图表现助教，对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。
                            和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...扮家家特训营效果图表现助教，
                            对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。
                            和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...图表现助教，
                            对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。
                            和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...
                            扮家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助扮家家特训营效果图表现助教，
                            对课程有任何疑问的都可以私聊我。和老师们一起助图表现助教，对课程有任何疑问的都可以私聊我。和老师们一起助...
                            图表现助教，对课程有任何疑问的都可以私聊我。家家特训营效果图表现助教，对课程有任何疑问的都可以私聊我。
                            和老师们一起助扮家家特训营效果图表现助教，可以和老师们一起助...
                        </div>
                    </div>
                    <div v-if="activeTab=='detail'" class="course-content-wrapper">
                        <div class="detail-container">
                            <div class="detail-wrapper">
                                <div class="detail-header-wrapper">
                                    <div :class="detailMode=='study'?'detail-header-item-active':'detail-header-item'"
                                    @click="handleDetailTab('study')">
                                        学习资料
                                    </div>
                                    <div :class="detailMode=='other'?'detail-header-item-active':'detail-header-item'"
                                    @click="handleDetailTab('other')">
                                        其他资料
                                    </div>
                                </div>
                                <div class="detail-content-wrapper">
                                    <div class="detail-content-item">
                                        <div class="detail-content">
                                            <div class="detail-content-img-wrapper">
                                                <img src="@/assets/img/v1.png" alt="" class="detail-content-img">
                                            </div>
                                            <div class="detail-content-label-wrapper">
                                                <div class="detail-content-label">
                                                    视频：全电发票在这些地方试点！
                                                </div>
                                                <div class="detail-content-date">13:45</div>
                                            </div>
                                        </div>
                                        <div v-if="detailMode=='study'" class="detail-content-btn">观看视频</div>
                                        <div v-if="detailMode=='other'" class="detail-download-btn-wrapper">
                                            <img src="@/assets/img/download1.png" alt="" class="detail-download-btn">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
export default {
    name: '',
    components:{
      Header
    },
    data() {
        return {
            activeTab:'brief',
            detailMode:'study'
        }
    },
    mounted(){
        
    },
    methods: {
        handleTab(target){
            if(target=='rules'){
                this.$router.push('/myRights/offline-course/rules');
            }else{
                this.activeTab=target;
            }
        },
        handleDetailTab(target){
            this.detailMode=target;
        },
        handleBack(){
            this.$router.push('/myRights/offline-courses');
        }
    }
}
</script>

<style scoped>
.page-container {
  width: 100%;
  margin: 0 auto;
}
.page-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 100px;
}
.card-container{
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #EAEAEA;
    display:flex;
    margin-top:18px;
    position: relative;
}
.card-wrapper{
    flex:1;
    margin:30px 45px 45px 45px;
}
.card-header{
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    position:relative;
}
.page-title-wrapper{
    flex:1;
    margin:20px 30px 20px 30px;
}
.header-title-wrapper{
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
    display:flex;
    align-items: center;
}
.header-title{
    margin-right:12px;
}
.header-title-img{
    width:20px;
    height:20px;
    display:inline-block;
    position:relative;
    top:3px;
}
.card-header-line{
    width: 6px;
    height: 24px;
    background: #3E63EE;
    border-radius: 3px;
    position:absolute;
    left:-45px;
    top:5px;
}
.card-content-wrapper{
    margin-top:23px;
}
.card-info{
    display:flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6D7A86;
    margin-bottom: 10px;
}
.clock-img{
    width:21px;
    height:21px;
    display:inline-block;
    margin-right:12px;
}
.card-info-icon{
    display:inline-block;
    margin-right:9px;
    font-size:24px;
    color:#C3C5CC;
    position:relative;
    left:-1px;
}
.card-info-btn-wrapper{
    display: flex;
    margin-top:30px;
}
.card-info-btn{
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    margin-right:20px;
}
.card-info-btn:hover{
    cursor:pointer;
    background:#3E63EE;
    color:#fff;
}
.course-container{
    margin-top:18px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #EAEAEA;
}
.course-header-wrapper{
    height: 60px;
    background: #F8FAFF;
    border-radius: 6px 6px 0px 0px;
    display:flex;
    background:#F8FAFF;
}
.course-header-item{
    width: 146px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    background: #F8FAFF;
    cursor:pointer;
}
.course-header-item-active{
    width: 146px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    background:#fff;
    cursor:pointer;
}
.course-content-header{
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    text-align: center;
    position:relative;
    width: 200px;
    margin: 0 auto;
    margin-top:58px;
}
.course-brief-content{
    width: 674px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 8px rgba(255, 241, 235, 0.25);
    border-radius: 6px;
    border: 1px solid #ECE7E4;
    margin:0 auto;
    margin-top:32px;
    padding:32px 27px 32px 27px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    letter-spacing: 1px;
}
.circle-img1-wrapper {
  position: absolute;
  top: -15px;
  left: 20px;
}
.circle-img1 {
  width: 33px;
  height: 33px;
}
.circle-img2-wrapper {
  position: absolute;
  top: -10px;
  right: 30px;
}
.circle-img2 {
  width: 18px;
  height: 18px;
}
.course-content-header-title{
    position:relative;
    z-index:20;
}
.course-content-wrapper{
    min-height:500px;
}
.detail-container{
    display:flex;
}
.detail-wrapper{
    flex:1;
    margin:40px 45px 70px 45px;
}
.detail-header-wrapper{
    display:flex;
    align-items: center;
}
.detail-header-item{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    margin-right:30px;
}
.detail-header-item:hover{
    cursor:pointer;
    color: #333333;
}
.detail-header-item-active{
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor:pointer;
    margin-right:30px;
}
.detail-content-item{
    display:flex;
    justify-content: space-between;
    margin-top:37px;
    padding-bottom:29px;
    border-bottom: 1px solid #F0F0F0;
}
.detail-content-btn{
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    display:flex;
    align-items: center;
    justify-content: center;
    margin-top:28px;
}
.detail-content-btn:hover{
    cursor: pointer;
    background: #3E63EE;
    color:#fff;
}
.detail-content{
    display:flex;
}
.detail-content-img-wrapper{
    width:148px;
    height:92px;
}
.detail-content-img{
    width:100%;
    height:100%;
}
.detail-content-label-wrapper{
    margin-left:50px;
    margin-top:8px;
}
.detail-content-label{
    width:600px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
}
.detail-content-date{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    margin-top:10px;
}
.detail-download-btn-wrapper{
    margin-top:28px;
}
.detail-download-btn{
    width:38px;
    height:38px;
    cursor:pointer;
}
.title-cursor{
    cursor:pointer;
}
</style>


